import React, { useRef, useEffect } from 'react';
import { cn } from '../../../utils/helper';

const AutoExpandingTextarea = ({ value, onChange, placeholder, name, readOnly, className }) => {
  const textareaRef = useRef(null);

  // Auto-expand functionality
  const adjustHeight = () => {
    if (textareaRef.current) {
      textareaRef.current.style.height = '96px'; // Reset height to minimum
      textareaRef.current.style.height = `${textareaRef.current.scrollHeight}px`; // Set height to scrollHeight
    }
  };

  // Adjust height when the component mounts or when the value changes
  useEffect(() => {
    adjustHeight();
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      className={cn(
        'dropdown-menu w-full text-[14px] min-h-[96px] resize-none bg-[#F4F4F4] border-2 border-[#E7E8EA] rounded-lg pl-[18px] pb-[30px] pt-[10px] relative dark:text-shoorah-darkBg dark:bg-shoorah-darkBgColor dark:border-none focus:outline-none overflow-hidden',
        className
      )}
      placeholder={placeholder}
      name={name}
      value={value}
      onChange={onChange}
      readOnly={readOnly}
    />
  );
};

export default AutoExpandingTextarea;
